import http from 'plugins/axios'

export default {
  getSymbolList(data) {
    return http.get({
      url: '/ta/admin/tenant/symbol/getSymbolList',
      data,
    })
  },
  // 合约
  getContractSymbolPage(data) {
    return http.get({
      url: `/ta/admin/tenant/contractSymbol/getContractSymbolPage`,
      data,
    })
  },

  updateContractSymbol(data) {
    return http.post({
      url: `/ta/admin/tenant/contractSymbol/updateContractSymbol`,
      data,
    })
  },

  // 现货
  getSpotSymbolPage(data) {
    return http.get({
      url: `/ta/admin/tenant/spotSymbol/getSpotSymbolPage`,
      data,
    })
  },

  updateSpotSymbol(data) {
    return http.post({
      url: `/ta/admin/tenant/spotSymbol/updateSpotSymbol`,
      data,
    })
  },

  updateContractSymbolPriceRate(data) {
    return http.post({
      url: `/ta/admin/tenant/contractSymbol/updateContractSymbolPriceRate`,
      data,
    })
  },
  // 风险限额
  getBracke(id) {
    return http.get({
      url: `/ta/admin/tenant/contractSymbol/${id}/leverage-bracket`,
    })
  },
}
